export const PHONE_DISPLAY = '+1 (825) 779-8783'
export const PHONE_TEL = 'tel:+18257798783'
export const OFFICE_ADDRESS = '#210 4503 Brisebois Dr NW, Calgary, AB T2L 2G3'
export const CANADIAN_LINE = '🍁 Proudly Canadian owned and operated'
export const SERVICE_AREA = 'Serving Calgary and surrounding communities'

export const NON_MEDICAL_DISCLAIMER =
  'True North Care & Support provides non-medical in-home care. Our caregivers do not provide nursing, diagnosis, medication administration or other medical services — those stay with your healthcare professionals.'
